module.exports = __webpack_public_path__ + "img/banca_abierta.cbffce82.jpeg";